import BaseIntegration from '@/common/mixins/integrations/baseIntegration';

const DuEtisalatIntegrationMixin = {
  extends: BaseIntegration,
  methods: {
    getPreRegistrationRedirectionActionImpl() {
      return () => {
        if (this.multiOperatorInfo.multiOperatorEnabled) {
          this.toggleSelectOperatorModal(true);
        } else {
          this.$router.push('register1');
        }
      };
    },
    getIntegrationParametersCheckImpl() {
      return (to) => {
        if (this.multiOperatorInfo.multiOperatorEnabled) {
          const correlationId = to.query.correlatorId;
          const userStatus = to.query.statusCode;
          if (correlationId && userStatus) {
            this.$axios.get(`api/getStatus?status=${userStatus}&correlationId=${correlationId}&lang=${this.getLocale}`).then((res) => {
              const statusResult = res.data.data[0];
              if (statusResult === 'FAILURE') {
                this.$router.push('/');
              } else if (statusResult === 'ALREADY_REGISTERED') {
                this.$router.push('login');
              } else if (statusResult === 'SUCCESS') {
                this.setRegistrationInfo(res.data.data[1]);
                this.storeOperator(res.data.data[2]);
                this.facebookReferral({ fbRef: res.data.data[3] });
                this.storeLoginInfo({
                  token: res.data.data[5],
                  rememberMeParameter: true,
                  username: res.data.data[6],
                });
                this.getUserLoginDetails().then(() => {
                  this.updateUserLanguage();
                  this.$router.push('home');
                });
              }
            });
          } else this.showPage(true);
          this.proceedToAutoLogin(to);
        }
      };
    },
    // ----------- reSub/unSub methods ----------------------------------
    alternateReSubActionImpl() {
      return (msisdn, operator) => {
        this.$axios.get(`api/getReSubUrl?msisdn=${msisdn}&operator=${operator}`).then((response) => {
          window.location.href = response.data.data;
        });
      };
    },
  },
};

export default DuEtisalatIntegrationMixin;



// WEBPACK FOOTER //
// ./src/common/mixins/integrations/duEtisalatIntegration.js